/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./mEmpty.vue?vue&type=template&id=7f96bc27&scoped=true"
import script from "./mEmpty.vue?vue&type=script&lang=js"
export * from "./mEmpty.vue?vue&type=script&lang=js"
import style0 from "./mEmpty.vue?vue&type=style&index=0&id=7f96bc27&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f96bc27",
  null
  
)

export default component.exports